<template>
  <div class="main">
    <ruth-header :tickets="true"></ruth-header>
    <div id="top"></div>
    <div id="container" :class="$i18n.locale">
      <!--<img src="../assets/img/tickets-ab.png" id="img-tickets-ab" class="animation-start">-->

      <div id="content">
        <div id="trailer" class="animation-start" @click="playVideo('BC5jZcqOKQU')">
          <span class="glyphicon glyphicon-play"></span>
          <span v-html="$t('main.trailer')"></span>
        </div>
        <div class="spacer spacer-100"></div>
        <h1 id="infos" v-html="$t('intro.header')"></h1>
        <div class="content-box">
          <span id="information">
            <span v-html="$t('intro.paragraph1')"></span>
            <br><br>
            <span v-html="$t('intro.paragraph2')"></span>
            <br><br>
            <span v-html="$t('intro.paragraph3')"></span>
          </span>
        </div>

        <div class="spacer spacer-50"></div>

        <!-- <h2 v-html="$t('audio.header')"></h2>
        <ruth-audio></ruth-audio>

        <div class="spacer spacer-50"></div> -->
        <h2 v-html="$t('slider.header')"></h2>
        <div id="carousel" class="carousel slide" data-ride="carousel" data-interval="5000">
          <slider></slider>
        </div>

        <!--<div class="quote-small">
          <div class="text" v-html="$t('main.quote-birgit')"></div>
          <div class="person" v-html="$t('main.quote-birgit-name')"></div>
        </div>

        <div class="spacer spacer-100"></div>-->

        <h1 id="termine" v-html="$t('events.header')"></h1>
        <events></events>

        <!--<div class="spacer spacer-100"></div>

        <div class="quote-big">
          <div class="text" v-html="$t('main.quote-hanna')"></div>
          <div class="verse" v-html="$t('main.quote-hanna-name')"></div>
        </div>

        <div class="spacer spacer-100"></div>-->

        <!--<h1 id="details" v-html="$t('main.details-header')"></h1>

        <div class="group-container">
          <div class="group" v-if="$t('accordion.info')">
            <div class="group-header" data-toggle="collapse" href="#content-8">
              <div class="group-title" v-html="$t('information.header')"></div>
              <div class="group-subtitle" v-html="$t('information.subheader')"></div>
            </div>
            <div class="group-content collapse" id="content-8">
              <group-information></group-information>
            </div>
          </div>
          <div class="group" v-if="$t('accordion.content')">
            <div class="group-header" data-toggle="collapse" href="#content-1">
              <div class="group-title">{{$t("content.header")}}</div>
              <div class="group-subtitle">{{$t("content.subheader")}}</div>
            </div>
            <div class="group-content collapse" id="content-1">
              <group-content></group-content>
            </div>
          </div>
          <div class="group" v-if="$t('accordion.news')">
            <div class="group-header" data-toggle="collapse" href="#content-2">
              <div class="group-title">{{$t("news.header")}}</div>
              <div class="group-subtitle">{{$t("news.subheader")}}</div>
            </div>
            <div class="group-content collapse" id="content-2">
              <group-news></group-news>
            </div>
          </div>
          <div class="group" v-if="$t('accordion.crew')">
            <div class="group-header" data-toggle="collapse" href="#content-3">
              <div class="group-title">{{$t("crew.header")}}</div>
              <div class="group-subtitle">{{$t("crew.subheader")}}</div>
            </div>
            <div class="group-content collapse" id="content-3">
              <group-crew></group-crew>
            </div>
          </div>
          <div class="group" v-if="$t('accordion.cast')">
            <div class="group-header" data-toggle="collapse" href="#content-4">
              <div class="group-title">{{$t("cast.header")}}</div>
              <div class="group-subtitle">{{$t("cast.subheader")}}</div>
            </div>
            <div class="group-content collapse" id="content-4">
              <group-cast></group-cast>
            </div>
          </div>
          <div class="group">
            <div class="group-header" data-toggle="collapse" href="#content-5">
              <div class="group-title">Fotos</div>
              <div class="group-subtitle">Die Galerie der Besten</div>
            <div>
            <div class="group-content collapse" id="content-5">

            </div>
          </div>
          <div class="group" v-if="$t('accordion.videos')">
            <div class="group-header" data-toggle="collapse" href="#content-6">
              <div class="group-title">{{$t("videos.header")}}</div>
              <div class="group-subtitle">{{$t("videos.subheader")}}</div>
            </div>
            <div class="group-content collapse" id="content-6">
              <group-videos :play-video="playVideo"></group-videos>
            </div>
          </div>
          <div class="group" v-if="$t('accordion.press')">
            <div class="group-header" data-toggle="collapse" href="#content-7">
              <div class="group-title">{{$t("press.header")}}</div>
              <div class="group-subtitle">{{$t("press.subheader")}}</div>
            </div>
            <div class="group-content collapse" id="content-7">
              <group-press></group-press>
            </div>
          </div>
          <div class="group">
            <div class="group-header" data-toggle="collapse" href="#content-9">
              <div class="group-title">{{$t("audience.header")}}</div>
              <div class="group-subtitle">{{$t("audience.subheader")}}</div>
            </div>
            <div class="group-content collapse" id="content-9">
              <group-audience-videos :play-video="playVideo"></group-audience-videos>
            </div>
          </div>
        </div>-->

        <div class="spacer spacer-50"></div>

        <!--<h1>{{$t("main.shop")}}</h1>
        <shop></shop>-->
      </div>

      <social-media></social-media>

      <ruth-footer></ruth-footer>
    </div>
  </div>
</template>

<script>
import "../bower_components/jquery/dist/jquery";
import "../assets/bootstrap/js/bootstrap";

import ruthHeader from "./GlobalSegments/Header";
import events from "./MainSegments/Events";
import groupInformation from "./MainSegments/GroupInformation";
import groupContent from "./MainSegments/GroupContent";
import slider from "./MainSegments/Slider";
import socialMedia from "./GlobalSegments/SocialMedia";
import ruthFooter from "./GlobalSegments/Footer";
import ruthOverlay from "./GlobalSegments/Overlay";

export default {
  name: "index",
  data() {
    return {};
  },
  components: {
    ruthHeader,
    events,
    groupInformation,
    groupContent,
    slider,
    socialMedia,
    ruthFooter,
    ruthOverlay
  },
  mounted() {
    $(".collapse")
      .on("show.bs.collapse", function() {
        $(this)
          .parent()
          .find(".group-header")
          .addClass("open");
      })
      .on("hide.bs.collapse", function() {
        $(this)
          .parent()
          .find(".group-header")
          .removeClass("open");
      });

    $(window).resize(setPlayerSize);

    function setPlayerSize() {
      let width = $(window).width();
      let player = $("#overlay");

      if (width > 900) {
        player.width("800px");
        player.height("460px");
      } else {
        player.width("100%");
        player.height(width / 16 * 9 + "px");
      }
    }

    setPlayerSize();
  },
  methods: {
    playVideo: function(id) {
      var loadedId = player.getVideoData()["video_id"];
      if (loadedId != id) {
        player.cueVideoById(id);
      }
      player.playVideo();
      $("#overlay, #overlay-background").removeClass("animate-hide");
      $("body").addClass("overflow-hidden");
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/texture";
@import "../assets/scss/var";

#container {
  width: $container_width;
  margin: 85px auto 0 auto;
  background: no-repeat $container_background_color;
  background-size: contain;
  padding-top: 720px;
  position: relative;
  animation: fade 1s forwards;

  &.de-AT {
    background-image: url("../assets/img/header.jpg")
  }

  &.en-GB {
    background-image: url("../assets/img/header.jpg")
  }

  @include media-big {
    width: 1000px;
    padding-top: 575px;
  }

  @include media-medium {
    width: 100%;
    padding-top: 55%;
  }

  @include media-small {
    margin: 50px auto 0 auto;
  }

  #img-tickets-ab {
    position: absolute;
    top: 0;
    width: 25%;
  }
}

#content {
  width: $content_width;
  margin: 0 auto;
  color: #fff;

  @include media-big {
    width: 800px;
  }

  @include media-medium {
    width: 100%;
    padding: 0 60px;
  }

  @include media-small {
    padding: 0;
  }

  #trailer {
    font-size: 55px;
    text-align: center;
    letter-spacing: 3px;
    cursor: pointer;

    @include media-phone {
      font-size: 35px;
    }

    .glyphicon {
      font-size: 45px;

      @include media-phone {
        font-size: 30px;
      }
    }
  }

  h1 {
    font-family: $condensed_font;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 70px;
    text-align: center;
    margin-bottom: 30px;
    @include textured_text;

    @include media-phone {
      font-size: 40px;
    }
  }

  h2 {
    font-size: 35px;
    letter-spacing: 3px;
    text-align: center;

    @include media-phone {
      font-size: 25px;
    }
  }

  .content-box {
    display: flex;
    margin: 0 auto;
    font-size: 20px;
    width: 600px;

    @include media-small {
      flex-direction: column;
    }

    @include media-tablet {
      width: 100%;
      padding: 0 20px;
    }

    > span {
      font-size: 18px;
      line-height: 25px;
      margin: 10px;

      &#information {
        text-align: center
      }

      @include media-small {
        margin: 0;
      }

      @include media-phone {
        font-size: 16px;
      }

      a {
        color: inherit;
      }
    }
  }
}

.quote-small {
  margin: 0 auto;
  width: 600px;
  text-align: center;

  @include media-tablet {
    width: 100%;
    padding: 0 20px;
  }

  .text {
    font-family: $slab_font;
    font-size: 30px;
    margin-bottom: 15px;

    @include media-phone {
      font-size: 20px;
    }
  }

  .person {
    font-size: 15px;
  }
}

.quote-big {
  > div {
    @include textured_text;
  }

  text-align: center;
  font-family: $slab_font;

  @include media-tablet {
    width: 100%;
    padding: 0 20px;
  }

  .text {
    font-size: 50px;

    @include media-phone {
      font-size: 35px;
    }
  }

  .verse {
    font-size: 30px;

    @include media-phone {
      font-size: 25px;
    }
  }
}

.group-container {
  .group {
    padding: 10px 0;
    border-bottom: 1px solid $golden_color;

    &:first-child {
      border-top: 1px solid $golden_color;
    }

    .group-header {
      padding: 10px 0 20px 0;
      cursor: pointer;
      position: relative;

      @include media-small {
        padding: 0 10px;
      }

      @include media-phone {
        padding: 0 10px;
      }

      .group-title {
        font-family: $condensed_font;
        font-weight: 700;
        font-size: 36px;
        margin-bottom: -4px;

        @include media-tablet {
          width: calc(100% - 40px);
        }

        @include media-phone {
          font-size: 25px;
        }
      }

      .group-subtitle {
        font-size: 26px;
        line-height: 26px;

        @include media-tablet {
          width: calc(100% - 40px);
        }

        @include media-phone {
          font-size: 18px;
          line-height: 18px;
        }
      }

      &:after {
        content: "\002b";
        font-family: $glyphicon_font;
        position: absolute;
        right: 10px;
        top: 30px;
        font-size: 25px;
        background-image: $texture;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        padding: 2px 9px;
        color: $container_background_color;

        @include media-small {
          top: 17px;
        }

        @include media-phone {
          height: 30px;
          width: 30px;
          padding: 3px 7px;
          font-size: 18px;
          top: 11px;
          right: 7px;
        }
      }

      &.open:after {
        content: "\2212";
        padding: 2px 7px;

        @include media-phone {
          padding: 3px 6px;
        }
      }
    }

    .group-content {
      margin-left: 25px;
      font-size: 20px;

      @include media-tablet {
        font-size: 16px;
        margin-left: 0;
        padding: 10px;
      }

      @include media-phone {
        font-size: 16px;
        margin-left: 0;
        padding: 10px;
      }
    }
  }
}

.video-container {
  .video {
    width: 32%;
    display: inline-block;
    padding: 10px;
    cursor: pointer;
    vertical-align: top;

    @include media-phone {
      width: 49%;
    }

    img {
      width: 100%;
    }

    .video-title {
      font-size: 20px;
      text-align: center;
      white-space: pre;

      @include media-phone {
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue